import Keycloak from "keycloak-js";

const keycloakConfig = {
  url: process.env.KEYCLOAK_URL,
  realm: process.env.KEYCLOAK_REALM,
  clientId: process.env.KEYCLOAK_CLIENT_ID
};

export default keycloakConfig;

export const keycloak = new Keycloak({
  ...keycloakConfig,
  kc_locale: 'es-ES'
});
